// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__3h1xV","tab":"TabNav_tab__3RfVQ","link":"TabNav_link__C70Uz","selectedLink":"TabNav_selectedLink__4rwsX","disabled":"TabNav_disabled__34sUO"};